// src/App.tsx - VERIFICADO E CORRIGIDO
import { useState } from "react";
import { SupabaseProvider } from "./providers/SupabaseProvider";
import CompaniesDashboard from "./pages/CompaniesDashboard";
import TemplatesDashboard from "./pages/TemplatesDashboard";

type ActiveSection = "companies" | "templates";

function App() {
  const [activeSection, setActiveSection] = useState<ActiveSection>("companies");

  return (
    <SupabaseProvider>
      <div className="App min-h-screen bg-background text-foreground font-sans">
        {/* Barra de Navegação */}
        <nav className="bg-card border-b border-border">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16">
              <div className="flex items-center space-x-8">
                {/* Logo/Title */}
                <div className="flex-shrink-0">
                  <h1 className="text-xl font-bold text-foreground">
                    Sistema Jurídico
                  </h1>
                </div>
                
                {/* Navegação */}
                <div className="hidden sm:flex space-x-4">
                  <button
                    onClick={() => setActiveSection("companies")}
                    className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                      activeSection === "companies"
                        ? "bg-primary text-primary-foreground"
                        : "text-muted-foreground hover:text-foreground hover:bg-muted"
                    }`}
                  >
                    Empresas
                  </button>
                  <button
                    onClick={() => setActiveSection("templates")}
                    className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                      activeSection === "templates"
                        ? "bg-primary text-primary-foreground"
                        : "text-muted-foreground hover:text-foreground hover:bg-muted"
                    }`}
                  >
                    Templates
                  </button>
                </div>
              </div>
            </div>
          </div>
        </nav>

        {/* Conteúdo Principal */}
        <main>
          {activeSection === "companies" && <CompaniesDashboard />}
          {activeSection === "templates" && <TemplatesDashboard />}
        </main>
      </div>
    </SupabaseProvider>
  );
}

export default App;